// extracted by mini-css-extract-plugin
export var card = "_p7-0";
export var content = "_p7-2";
export var details = "_p7-3";
export var icon = "_p7-1";
export var iconBlue = "_p7-5";
export var iconBrand = "_p7-4";
export var iconGrayBlue = "_p7-6";
export var iconGreen = "_p7-7";
export var iconIndigo = "_p7-8";
export var iconOrange = "_p7-9";
export var iconPurple = "_p7-a";
export var iconRed = "_p7-b";
export var iconWarning = "_p7-c";